import { InputFile } from './InputFile'
import { InputFileContainer } from './InputFile.container'

export default Object.assign(InputFile, {
	Container: InputFileContainer
})
